// removed by extract-text-webpack-plugin
module.exports = {"Order":"-name__-loca-__4yi4Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 193
// module chunks = 0